import React from 'react';
import PropTypes from 'prop-types';

const GuestBrandedThemeWrapper = ({ children, theme }) => (
    <div className={'guest-branded'} style={theme}>
        {children}
    </div>
);

GuestBrandedThemeWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    theme: PropTypes.objectOf(PropTypes.string),
};

GuestBrandedThemeWrapper.defaultProps = {
    theme: {},
};

export default GuestBrandedThemeWrapper;
